import { render, staticRenderFns } from "./exhibitionPage.vue?vue&type=template&id=22c44692&scoped=true"
import script from "./exhibitionPage.vue?vue&type=script&lang=js"
export * from "./exhibitionPage.vue?vue&type=script&lang=js"
import style0 from "./exhibitionPage.vue?vue&type=style&index=0&id=22c44692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c44692",
  null
  
)

export default component.exports